import React, { useState, useEffect } from 'react';
import { Grid, Typography, CircularProgress, Box, List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchSnowflakeDataSourceById, fetchAllSnowflakeDataSources } from '../../lib/services/snowflakeDataSourceService';
import SnowflakeDataSourceDetail from './SnowflakeDataSourceDetail';

const SnowflakeDataSourcesPage = ({ drawerWidth, idToken }) => {
    const { dataSourceId } = useParams();

    const [dataSource, setDataSource] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [allDataSources, setAllDataSources] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        if (!idToken) return;

        fetchAllSnowflakeDataSources(idToken, setAllDataSources, () => {}, () => {});

        if (dataSourceId) {
            fetchSnowflakeDataSourceById(idToken, dataSourceId, setDataSource, setLoading, setError);
        } else {
            setLoading(false);
        }
    }, [idToken, dataSourceId]);

    if (loading) {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                style={{
                    marginTop: '30px',
                    marginLeft: drawerWidth,
                    height: 'calc(100vh - 100px)'
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Grid
            container
            spacing={2}
            style={{
                marginTop: '30px',
                marginLeft: drawerWidth,
                height: '100%',
                width: `calc(95% - ${drawerWidth}px)`
            }}
        >
            <Grid item xs={2.5} style={{ height: '91.5vh', borderRight: '1px solid #eee', overflow: 'auto' }}>
                <Typography variant="h6" sx={{ padding: '16px', borderBottom: '1px solid #eee' }}>
                    Snowflake Data Sources
                </Typography>
                <List>
                    {allDataSources.map((ds) => (
                        <ListItem key={ds.id} disablePadding>
                            <ListItemButton
                                selected={dataSourceId === ds.id}
                                onClick={() => navigate(`/snowflake-data-sources/${ds.id}`)}
                            >
                                <ListItemText
                                    primary={`${ds.database}.${ds.schema}`}
                                    secondary={ds.warehouse}
                                    primaryTypographyProps={{
                                        style: { fontSize: '0.9rem' }
                                    }}
                                />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Grid>
            <Grid item xs={9.5}>
                <SnowflakeDataSourceDetail dataSource={dataSource} loading={false} error={error} />
            </Grid>
        </Grid>
    );
};

export default SnowflakeDataSourcesPage;
